export default __webpack_public_path__ + "static/spiritual-maya-hotel-1-37116fd44c7e5bb3ff055a736f8d0859.jpg";